import script from "./ProjectAddRoleDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectAddRoleDropdown.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectAddRoleDropdown.vue?vue&type=style&index=0&id=ceec591e&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ceec591e"]])

export default __exports__